import { render, staticRenderFns } from "./userOpenManage.vue?vue&type=template&id=79970208&scoped=true&"
import script from "./userOpenManage.vue?vue&type=script&lang=ts&"
export * from "./userOpenManage.vue?vue&type=script&lang=ts&"
import style0 from "./userOpenManage.vue?vue&type=style&index=0&id=79970208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79970208",
  null
  
)

export default component.exports